import Route from '@ember/routing/route';
import { instrumentRoutePerformance } from '@sentry/ember';

class SettingsAgentsAgentEditRoute extends Route {
  model() {
    return this.modelFor('settings.agents.agent');
  }
}

export default instrumentRoutePerformance(SettingsAgentsAgentEditRoute);
